import {ProjectView_AccessControl} from "../../access/acl"
import ProjectView from "../../project-view"

export class ProjectView_Link_AccessControl extends ProjectView_AccessControl {

    constructor(projectView:ProjectView) {
        super(projectView)
    }

    get canRename():boolean {
        return true
    }

    get canEditSource():boolean {
        return this.isPrivateViewOwner || this.hasFullAccess
    }

    get canCreateNew():boolean {
        return this.hasFullAccess
    }

    get canDuplicate():boolean {
        return this.isPrivateViewOwner || this.hasFullAccess
    }

    get canResetToDefault():boolean {
        return false
    }

    get canDelete():boolean {
        return this.isPrivateViewOwner || this.hasFullAccess
    }

    get canUseTemplates():boolean {
        return false
    }

    get canSaveAsTemplate():boolean {
        return false
    }

    get canLoadTemplate():boolean {
        return false
    }

    get canEditPermissions():boolean {
        return this.isPrivateViewOwner || this.hasFullAccess
    }

    get canSetPublicPermission():boolean {
        return this.hasFullAccess
    }

    get canSetAsToDefault():boolean {
        return false
    }
}

